module.exports = __webpack_public_path__ + "static/assets/afc646fe671f2f43cf0deb3f2247b8bf.svg";